export const PermissaoUsuarioEnum = {
	VISUALIZAR: "VISUALIZAR_USUARIO",
	CRIAR: "CRIAR_USUARIO",
	EXCLUIR: "EXCLUIR_USUARIO",
};

export const PermissaoGrupoUsuarioEnum = {
	VISUALIZAR: "VISUALIZAR_GRUPO_USUARIO",
	CRIAR: "CRIAR_GRUPO_USUARIO",
	EXCLUIR: "EXCLUIR_GRUPO_USUARIO",
};

export const PermissaoSistemaOperacionalEnum = {
	VISUALIZAR: "VISUALIZAR_SISTEMA_OPERACIONAL",
	CRIAR: "CRIAR_SISTEMA_OPERACIONAL",
	EXCLUIR: "EXCLUIR_SISTEMA_OPERACIONAL",
};

export const PermissaoModeloMaquinaEnum = {
	VISUALIZAR: "VISUALIZAR_MODELO_MAQUINA",
	CRIAR: "CRIAR_MODELO_MAQUINA",
	EXCLUIR: "EXCLUIR_MODELO_MAQUINA",
};

export const PermissaoCategoriaDriverEnum = {
	VISUALIZAR: "VISUALIZAR_CATEGORIA_DRIVER",
	CRIAR: "CRIAR_CATEGORIA_DRIVER",
	EXCLUIR: "EXCLUIR_CATEGORIA_DRIVER",
};

export const PermissaoDriverEnum = {
	VISUALIZAR: "VISUALIZAR_DRIVER",
	CRIAR: "CRIAR_DRIVER",
	EXCLUIR: "EXCLUIR_DRIVER",
};

export const PermissaoMaquinaEnum = {
	VISUALIZAR: "VISUALIZAR_MAQUINA",
	CRIAR: "CRIAR_MAQUINA",
	EXCLUIR: "EXCLUIR_MAQUINA",
};

export const PermissaoVersaoSistemaEnum = {
	VISUALIZAR_TELA: "VISUALIZAR_TELA_VERSAO_SISTEMA",
	VISUALIZAR: "VISUALIZAR_VERSAO_SISTEMA",
	CRIAR: "CRIAR_VERSAO_SISTEMA",
	EXCLUIR: "EXCLUIR_VERSAO_SISTEMA",
};
